import { Component, Inject, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import PerfectScrollbar from 'perfect-scrollbar';

import { environment } from '../../environments/environment';

declare var $: any;
//Metadata
export interface RouteInfo {
    path: string;
    requireLogin: boolean;
    RouteRoles: RouteRoleItems[];
    title: string;
    type: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    RouteRoles: RouteRoleItems[];
}

export interface RouteRoleItems {
    RouteRole: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard',
        requireLogin: false,
        RouteRoles: [{ RouteRole: '' }],
        title: 'Dashboard',
        type: 'link',
        icontype: 'ti-panel'        
    },{
        path: '/patientmanagement',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'LINESUser' }, { RouteRole: 'HRNUser' }, { RouteRole: 'OMSUser' }, { RouteRole: 'VERITASUser' }],
        title: 'Patient-Management',
        type: 'sub',
        icontype: 'ti-user',
        children: [
            { path: 'patientregistration', title: 'Patient Registration', ab: 'PR', RouteRoles: [{ RouteRole: 'LINESUser' }, { RouteRole: 'HRNUser' }, { RouteRole: 'OMSUser' }, { RouteRole: 'VERITASUser' }] },
            //{ path: 'eligibility', title: 'AMED', ab: 'AM', RouteRoles: [{ RouteRole: 'SRNUser'}] },
            { path: 'patienttable', title: 'Patient List LINES/HRN', ab: 'PL', RouteRoles: [{ RouteRole: 'LINESUser' }, { RouteRole: 'HRNUser' }] },
        ]
    },{
        //path: '/usermanagement',
        path: '/usermanagement/userdetail',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'SRNHelpdesk' }],
        title: 'User-Management',
        //type: 'sub',
        type: 'link',
        icontype: 'ti-user'//,
        //children: [
            //{ path: 'userdetail', title: 'Users', ab: 'SRN', RouteRoles: [{ RouteRole: '' }] },
            //{ path: 'usertable', title: 'Azure Active Directory', ab: 'AAD', RouteRoles: [{ RouteRole: '' }] },
            //{ path: 'usercontexttable', title: 'EUPID Contexts', ab: 'CTX', RouteRoles: [{ RouteRole: '' }] },
            //{ path: 'userdcptable', title: 'LINES / HRNBL15N', ab: 'DCP', RouteRoles: [{ RouteRole: '' }] }
            
        //]
    },{
        path: '/portalmanagement',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'SRNHelpdesk' }],
        title: 'Portal-Management',
        type: 'sub',
        icontype: 'ti-settings',
        children: [
            { path: 'aadmanagement', title: 'AAD Management', ab: 'AM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'eupidmanagement', title: 'EUPID Management', ab: 'EM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'linesmanagement', title: 'LINES Management', ab: 'LM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'hrnbl15nmanagement', title: 'HRNBL15N Management', ab: 'HM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'log', title: 'Log', ab: 'LG', RouteRoles: [{ RouteRole: '' }] },
        ]
    }
];

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent {
    public menuItems: any[];
    instance: string;
    private roles: any[];
    private readonly _destroying$ = new Subject<void>();

    isNotMobileMenu(){
        if (window.outerWidth > 991){
            return false;
        }
        return true;
    }
    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private msalBroadcastService: MsalBroadcastService
    ) {
        this.instance = environment.instanceString;

        this.msalService.instance.initialize()
            .then(response => {
                //
            })
            .catch((error) => {
                console.error(error);
            });

        this.msalBroadcastService.msalSubject$
            .subscribe((result: EventMessage) => {
                if (result.eventType === EventType.LOGIN_SUCCESS) {
                    const payload = result.payload as AuthenticationResult;
                    this.msalService.instance.setActiveAccount(payload.account);

                    this.initView();
                }
            });
    }
    
    ngOnInit() {
        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe((status: InteractionStatus) => {
            })

        
            
        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        
        this.initView();

        isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        const html = document.getElementsByTagName('html')[0];
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            let ps = new PerfectScrollbar(<HTMLElement>document.querySelector('.sidebar .sidebar-wrapper, .main-panel'));
            html.classList.add('perfect-scrollbar-on');
        } else {
            html.classList.add('perfect-scrollbar-off');
        }
    }

    private initView() {
        if (this.isLoggedIn() === true) {
            this.menuItems = ROUTES.filter(menuItem => menuItem.RouteRoles.find(role => role.RouteRole === ''));
            if (!this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles) {
                this.msalService.instance.getActiveAccount().idTokenClaims.roles = [];
            }
            for (let item of ROUTES) {
                let itemExists = false;
                let actualChildren = [];
                for (let userRole of this.msalService.instance.getActiveAccount().idTokenClaims.roles) {
                    for (let routeRole of item.RouteRoles) {
                        if (routeRole.RouteRole == userRole) {
                            if (!itemExists) {
                                itemExists = true;
                                if (item.children) {
                                    for (let child of item.children) {
                                        let childExists = false;
                                        for (let childUserRole of this.msalService.instance.getActiveAccount().idTokenClaims.roles) {
                                            for (let childRole of child.RouteRoles) {
                                                if (childRole.RouteRole == childUserRole || childRole.RouteRole == '') {
                                                    if (!childExists) {
                                                        actualChildren.push(child);
                                                        childExists = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                item.children = actualChildren;
                                this.menuItems.push(item);
                            }
                        }
                    }
                }
            }
        } else {
            this.menuItems = ROUTES.filter(item => item.requireLogin === false);
        }
    }

      
    login() {
        this.msalService.instance.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    }

    logout() {
        this.msalService.instance.logoutRedirect();
    }

    isLoggedIn(): boolean {
        const loggedIn = this.msalService.instance.getActiveAccount() != null;
        return loggedIn;
    }

    userInfo() {
        return this.msalService.instance.getActiveAccount();
    }

    ngAfterViewInit(){
        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();
        var collapseId = $sidebarParent.siblings('a').attr("href");
        $(collapseId).collapse("show");
    }
}
